// This is used to identify page split points and display only page elements.
const PageTitle = () => null;

export default PageTitle;

export const createPageTitle = title => ({
  'ui:field': PageTitle,
  'ui:title': title
});
